const listLayananKonsumen = () => ({})
const listLayananOwner = () => ({})

const state = {
	listLayananKonsumen: listLayananKonsumen(),
	listLayananOwner: listLayananOwner(),
}

export {
	state as default,
	listLayananKonsumen,
	listLayananOwner,
}